import { render, staticRenderFns } from "./MassGlobalConfig.vue?vue&type=template&id=ca0c5fe2&"
import script from "./MassGlobalConfig.vue?vue&type=script&lang=js&"
export * from "./MassGlobalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports